import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4()
}

function getJwt() {
  const jwt = Cookies.get('jwt')
  return jwt
}

function getUser() {
  const token = getJwt()
  if (!token) {
    return {}
  }
  try {
    return jwtDecode(token)
  } catch (e) {
    return {}
  }
}

function getUUID() {
  let uuid = Cookies.get('uuid')
  if (!uuid) {
    uuid = guid()
    Cookies.set('uuid', uuid)
  }
  return uuid
}

function isLoggedIn() {
  return !!getJwt() && getUser().mobile && getUser().userId
}

export {
  isLoggedIn,
  getUser,
  getUUID,
  guid

}



// WEBPACK FOOTER //
// ./client/utils/auth.js